var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6666 2.25C6.11028 2.25 2.41663 5.94365 2.41663 10.5C2.41663 15.0563 6.11028 18.75 10.6666 18.75C15.223 18.75 18.9166 15.0563 18.9166 10.5C18.9166 5.94365 15.223 2.25 10.6666 2.25ZM0.916626 10.5C0.916626 5.11522 5.28185 0.75 10.6666 0.75C16.0514 0.75 20.4166 5.11522 20.4166 10.5C20.4166 15.8848 16.0514 20.25 10.6666 20.25C5.28185 20.25 0.916626 15.8848 0.916626 10.5Z",
    fill: "#3E4359"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16663 9.75C9.16663 9.33579 9.50241 9 9.91663 9H10.6666C11.0808 9 11.4166 9.33579 11.4166 9.75V14.25C11.8308 14.25 12.1666 14.5858 12.1666 15C12.1666 15.4142 11.8308 15.75 11.4166 15.75H10.6666C10.2524 15.75 9.91663 15.4142 9.91663 15V10.5C9.50241 10.5 9.16663 10.1642 9.16663 9.75Z",
    fill: "#3E4359"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 7.5C11.2879 7.5 11.7916 6.99632 11.7916 6.375C11.7916 5.75368 11.2879 5.25 10.6666 5.25C10.0453 5.25 9.54163 5.75368 9.54163 6.375C9.54163 6.99632 10.0453 7.5 10.6666 7.5Z",
    fill: "#3E4359"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.2a58e0fdd3982d2e6409b58b11df38e0.svg";
export { ForwardRef as ReactComponent };